import { AuthApi, CasesApi, IS_ESOFT_USER_KEY } from 'api';
import appRoutes from 'app.routes';
import { useEffect } from 'react';
import qs from 'qs';
import {
  AUTH_REDIRECT_URL,
  AUTH_REFRESHING,
  AUTH_RESET_PASSWORD_KEY,
  LAST_DEPARTMENT_ID,
  MINDWORKING_REDIRECT_REFERENCE,
  RESET_PASSWORD_CODE_KEY,
} from 'api/http';
import { useQueryClient } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';

const AuthRedirectPageContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const client = useQueryClient();

  const debouncedOnLogout = useDebouncedCallback(() => {
    const clearData = () => {
      const locale = localStorage.getItem('locale');
      const i18nextLng = localStorage.getItem('i18nextLng');
      const branchId = localStorage.getItem(LAST_DEPARTMENT_ID);
      localStorage.clear();
      if (locale) localStorage.setItem('locale', locale);
      if (branchId) localStorage.setItem(LAST_DEPARTMENT_ID, branchId);
      if (i18nextLng) localStorage.setItem('i18nextLng', i18nextLng);
      client.removeQueries();
    };
    clearData();
    navigate(appRoutes.login());
  }, 1000);

  // const debouncedNavigate = useDebouncedCallback(route => navigate(route), 1000) // old logic, debouncedNavigate is not needed here

  useEffect(() => {
    const { id_token, error_description } = qs.parse(location.hash);

    // after password reset
    if (typeof error_description === 'string') {
      const resetPasswordErrorCode = localStorage.getItem(RESET_PASSWORD_CODE_KEY);
      const resetPasswordUrl = localStorage.getItem(AUTH_RESET_PASSWORD_KEY);
      if (resetPasswordUrl && resetPasswordErrorCode && error_description.includes(resetPasswordErrorCode)) {
        window.location.href = resetPasswordUrl;
        return;
      }
    }
    console.log('location', location);
    // after logout
    if (!id_token) {
      debouncedOnLogout();
      return;
    }

    AuthApi.persistToken(id_token as string);

    // happens in hidden iframe to refresh token, no need to redirect
    if (localStorage.getItem(AUTH_REFRESHING) === 'true' && window.self !== window.top) {
      localStorage.removeItem(AUTH_REFRESHING);
      return;
    }

    // after log in
    if (localStorage.getItem(IS_ESOFT_USER_KEY) === 'true') {
      // debouncedNavigate(appRoutes.activeDirectory()) old logic, debouncedNavigate is not needed here
      navigate(appRoutes.activeDirectory());
    } else {
      const mindworkingReference = localStorage.getItem(MINDWORKING_REDIRECT_REFERENCE);

      if (mindworkingReference) {
        CasesApi.getDatahubCases({
          query: mindworkingReference,
        }).then(({ items }) => {
          const foundCaseId = items?.[0]?.id;
          if (foundCaseId) {
            localStorage.removeItem(MINDWORKING_REDIRECT_REFERENCE);
            navigate(appRoutes.cases.details(foundCaseId));
          }
        });
        return;
      }

      const redirectUrl = localStorage.getItem(AUTH_REDIRECT_URL);
      localStorage.removeItem(AUTH_REDIRECT_URL);
      navigate(redirectUrl || appRoutes.dashboard());
    }
  }, []);

  return null;
};

export default AuthRedirectPageContent;
